import { useUser } from 'src/utils/authentication';
import { isSupplier } from 'src/utils/permissions';

export default function useIsSupplier() {
  const { data: user } = useUser();
  const userIsSupplier = isSupplier(user);

  return userIsSupplier;
}
